var _path;
import * as React from "react";
function SvgBarsSortUp(props) {
  return /*#__PURE__*/React.createElement("svg", props, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.715 12.286a1.285 1.285 0 00.909-2.195l-7.715-7.714a1.285 1.285 0 00-1.818 0l-7.714 7.714a1.285 1.285 0 101.818 1.818l5.52-5.52v30.325A1.29 1.29 0 0020 38c.707 0 1.286-.575 1.286-1.286V6.39l5.52 5.52c.25.247.579.376.909.376z"
  })));
}
export default SvgBarsSortUp;